import { Component, createRef } from 'react';
import { formatNumber, showNotification, handleClickOutside, navigateTo, isDesktop, isMobile } from "../../../lib/helper";
import { connect } from "react-redux";
import { fetchingUser, fetchingUserSuccess, updateAppConfigAction } from "../../../redux/actions";
import { withRouter } from "react-router-dom";
import api from "../../../lib/api";
import constants from '../../../lib/constants';
import { withTranslation } from 'react-i18next';
import { useSnackbar } from "notistack";
class Deposit extends Component {
	constructor(props) {
		super(props);
		this.state = {
			deposit_value: 0,
			deposit_transaction: '',
			is_show_deposit_success: false,
		};
		this.refList = {
			is_show_deposits: createRef(),
			is_show_deposit_success: createRef(),
		};
	}

	componentDidMount() {
		document.addEventListener('click', handleClickOutside.bind(this));
	}

	componentWillUnmount() {
		document.removeEventListener('click', handleClickOutside.bind(this))
	}

	onShowDeposit = () => {
		this.props.updateAppConfigAction({ ['is_show_deposit']: !this.props.appReducer['is_show_deposit'] });
	}

	onChangeDeposit = (e) => {
		let deposit_value = parseFloat(e.target.value.toString().replace(/,/g, ''));
		this.setState({ deposit_value });
	}
	setAllMoney = (e) => {
		e.preventDefault();
		this.setState({ deposit_value: this.props.memberReducer.deposit_balance });
	}
	onRecharge = (e) => {
		let { enqueueSnackbar } = this.props;
		e.preventDefault();
		let { deposit_value } = this.state;
		api.postDeposit(deposit_value, constants.TRANSACTION_TYPE.MAIN_TO_TRANSACTION).then(({ success, message }) => {
			if (success) {
				this.props.fetchingUser();
				showNotification(enqueueSnackbar, { message, type: 'success' });
			}
			else {
				showNotification(enqueueSnackbar, { message, type: 'danger' });
			}
		})
	}

	render() {
		let { deposit_value, deposit_transaction, is_show_deposit_success } = this.state;
		let { minimum_deposit, bank_data, vnd_per_usd, is_show_deposit, } = this.props.appReducer;
		let { deposit_balance } = this.props.memberReducer;
		let isDisabledRecharge = isNaN(deposit_value) || deposit_value < minimum_deposit || deposit_value > deposit_balance;
		let { t } = this.props;
		let totalAmount = deposit_balance;
		bank_data = (bank_data || '').replace(/\r?\n/g, '<br/>');
		return <li data-v-bd82969a="" className="qDeposit" ref={this.refList.is_show_deposits}>
			{isDesktop() && <button data-v-bd82969a=""
				onClick={this.onShowDeposit}
				className="btn button btn-border btn-qDeposit" style={{ borderRadius: '6px' }}>
				<span data-v-bd82969a="" className="icon">
					<svg data-v-bd82969a=""
						id="icon-deposit-green"
						xmlns="http://www.w3.org/2000/svg"
						width="16.684"
						height="14.693"
						viewBox="0 0 16.684 14.693"><g
							data-v-bd82969a="" id="icon-deposit"><path
								data-v-bd82969a="" id="Combined-Shape"
								d="M7.129,4.722c.033-.033.071-.054.1-.086a5.406,5.406,0,0,0-1.792-.327,5.442,5.442,0,1,0,4.734,8.077L7.123,9.332A3.258,3.258,0,0,1,7.129,4.722Zm9.236,1.539a1.082,1.082,0,0,0-1.532-.008L13.6,7.481v-5.9a1.088,1.088,0,0,0-2.177,0v5.9L10.2,6.253a1.089,1.089,0,0,0-1.54,1.54l3.093,3.092a1.067,1.067,0,0,0,.758.311,1.054,1.054,0,0,0,.767-.311l3.093-3.092A1.089,1.089,0,0,0,16.365,6.261Z"
								transform="translate(0 -0.5)" fill="#fff"
								fillRule="evenodd" /></g>
					</svg>
				</span>
				<span data-v-bd82969a="" className="colorWhite">{t('QuickRecharge')}</span>
			</button>}
			{is_show_deposit && <div data-v-110c803e="" data-v-bd82969a="">
				<div data-v-110c803e="" className="dropdown-menu qDeposit show">
					<div data-v-110c803e="" className="wrap">
						{isMobile() &&
							<div className='d-flex w-100 justify-content-between pb-3 mb-3'>
								<p className='font-20 font-weight-bold'>{t("QuickRecharge")}</p>
								<div data-v-f99ecb42="" onClick={this.onShowDeposit} style={{ fontSize: '35px', marginRight: '5px', background: 'transparent' }} className="close-page text-white">
									<span data-v-f99ecb42="" className="pe pe-7s-close" />
								</div>
							</div>}
						<div data-v-110c803e="" className="block py-2">
							<p data-v-110c803e="" className="colorWhite mb-2 title">{t('ChooseWallet')}</p>
							<form data-v-110c803e="" style={{}}>
								<div data-v-110c803e=""
									className="form-group bg-white form-control gap-1 d-flex align-items-center position-relative input-amount">
									<img className='img-fluid' id="_825" data-name="825" width="20" height="20" src="data:image/png;base64,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" />
									<input data-v-110c803e="" type="text"
										onChange={this.onChangeDeposit}
										value={formatNumber(totalAmount)}
										className="w-100 text-black pb-0 pl-1" style={{ background: 'transparent' }} />

								</div>
								<p data-v-110c803e="" className="colorWhite mb-2 title">{`${t('DepositOn')}`}</p>
								<div data-v-110c803e=""
									className="form-group bg-white position-relative d-flex input-amount">
									<input data-v-110c803e="" type="text"
										placeholder="Vui lòng nhập số tiền"
										value={formatNumber(deposit_value)}
										onChange={this.onChangeDeposit}
										className="form-control text-black" />
									<a href='' className='d-flex align-items-center' onClick={this.setAllMoney}>
										<span className='colorBlue4 font-12 whitespace-nowrap text-uppercase mr-2'>{t('All')}</span>
									</a>
								</div>
							</form>
							{/* <form data-v-110c803e="">
								
							</form> */}
							{/* <p data-v-110c803e="" className="noticeDeposit">
								<small data-v-110c803e="">Giá trị nạp tối thiểu là ${formatNumber(minimum_deposit)}</small>
								<br />
								<small data-v-110c803e="">(Tỉ giá quy đổi $1 = {formatNumber(vnd_per_usd)}VNĐ)</small>
							</p> */}
							<div data-v-110c803e="" className="sizeLarge">
								<p data-v-110c803e="" className="colorWhite mb-2 title">*{t('TotalReceive')}</p>
								<p data-v-110c803e="" className="receiveAmount colorBlue4 colorWhite mb-2">${formatNumber(deposit_value)}</p>
							</div>
							{/* {is_show_deposit_success && <div>
								<div data-v-110c803e="" className="noticeDeposit" style={{ color: 'green', marginBottom: '7px', fontStyle: 'normal' }}>{t('RequestSuccess')}</div>
								<div data-v-110c803e="" className="noticeDeposit"><small>{`${t('TransferInfo.Warn')} ${formatNumber(deposit_value)}VNĐ ${t('TransferInfo.ToAccount')}`}</small></div>
								<div data-v-110c803e="" className="noticeDeposit deposit" dangerouslySetInnerHTML={{ __html: bank_data }} />
								<div data-v-110c803e="" className="noticeDeposit deposit"><small>{t('TransferInfo.Content')}:</small> {deposit_transaction}</div>
								<div data-v-110c803e="" className="noticeDeposit deposit">
									<span style={{ color: 'red' }}>{t('TransferInfo.Warning1')}</span><br />
									<span style={{ color: 'red' }}>( {t('TransferInfo.Warning2')} )</span>
								</div>
							</div>} */}
						</div>
						<div data-v-110c803e="" className="block mobileFooter">
							<div data-v-110c803e="" className="sizeSmall">
								<div data-v-110c803e="" className="amount d-flex pdb-15">
									<span data-v-110c803e=""
										className="colorWhite mb-2 title">{t('TotalReceive')}*</span>
									<span data-v-110c803e=""
										className="receiveAmount colorWhite mb-2 text-right"><b
											data-v-110c803e="">${formatNumber(deposit_value)}</b></span></div>
							</div>
							{<button data-v-110c803e="" disabled={deposit_value <= 0 || deposit_value > deposit_balance}
								onClick={this.onRecharge}
								className="btn btn-secondary w-100 btn-confirm mb-2 colorWhite"
								style={{ color: 'white', backgroundColor: deposit_value <= 0 || deposit_value > deposit_balance ? '#858585' : '#31BAA0' }}>
								<b data-v-110c803e="">{t('Confirm')}</b>
							</button>}
						</div>
					</div>
				</div>
			</div>}
		</li>
	}
}

function mapStateToProps(state) {
	return {
		memberReducer: state.memberReducer,
		appReducer: state.appReducer
	};
}
const withSnackbar = (Component) => (props) => {
	const { enqueueSnackbar } = useSnackbar();
	return <Component {...props} enqueueSnackbar={enqueueSnackbar} />;
};
export default connect(mapStateToProps, {
	fetchingUser,
	fetchingUserSuccess,
	updateAppConfigAction
})(withRouter(withTranslation()(withSnackbar(Deposit))));

